export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqData: FAQItem[] = [
  {
    id: "what-is-forkast",
    question: "What is forkast?",
    answer: "forkast is a family meal planning app that helps busy families organize their weekly meals, share the mental load, and build better eating habits. It's designed by real parents to remove the stress from meal planning."
  },
  {
    id: "how-does-it-work",
    question: "How does forkast work?",
    answer: "forkast works in three simple steps: 1) Build your recipe collection by importing from any website or adding your family favorites, 2) Plan together using the shared calendar for breakfast, lunch and dinner, 3) Generate smart shopping lists organized by category from your planned meals."
  },
  {
    id: "is-it-free",
    question: "Is forkast free to use?",
    answer: "Yes, forkast is currently free to use during our beta phase. You can start planning meals for your family without any credit card or payment required."
  },
  {
    id: "family-sharing",
    question: "Can my whole family use forkast?",
    answer: "Absolutely! forkast is designed for families. You can invite your partner and kids to join your family circle. Everyone can contribute to meal planning, leave ratings and comments on recipes, and see the weekly meal plan."
  },
  {
    id: "recipe-import",
    question: "How do I add recipes to forkast?",
    answer: "You can add recipes in several ways: import directly from recipe websites by pasting the URL, upload an image of a recipe to extract ingredients and instructions, create quick recipes with our simple form, or manually add your family's favorite recipes with ingredients and instructions."
  },
  {
    id: "shopping-lists",
    question: "How do the shopping lists work?",
    answer: "Once you've planned your meals for the week, forkast automatically generates a smart shopping list organized by category (produce, proteins, pantry items, etc.). The list updates instantly as you add or remove meals from your plan."
  },
  {
    id: "shopping-focus-mode",
    question: "What is shopping list focus mode?",
    answer: "Focus mode helps you shop more efficiently by highlighting one category at a time. This makes it easier to navigate the store section by section, reducing the chance of forgetting items and making your shopping trip more organized."
  },
  {
    id: "wellness-insights",
    question: "What are wellness insights?",
    answer: "forkast provides AI-powered insights about your family's eating patterns, including nutrition indicators, dietary balance feedback, and recommendations for healthier meal planning. Please note that these insights are AI-generated and not professional medical or nutritional advice."
  },
  {
    id: "adding-notes",
    question: "Can I add notes to recipes?",
    answer: "Yes! You can add personal notes to any recipe in your collection. Use notes to remember modifications you made, cooking tips that work for your family, or reminders about ingredients your family loves or dislikes."
  },
  {
    id: "data-privacy",
    question: "How secure is my family's data?",
    answer: "We take your privacy seriously. Your family's meal plans, recipes, and personal information are securely stored and never shared with third parties. You control your data and can delete your account at any time."
  },
  {
    id: "mobile-app",
    question: "Is there a mobile app?",
    answer: "Yes! forkast works like a native app on any device. You can <a href='/install' class='text-terracotta hover:text-terracotta-dark underline'>install it on your home screen</a> for quick access - no app store needed. It works offline and is optimized for both phone and tablet use, providing a full-featured experience on all devices."
  },
  {
    id: "beta-feedback",
    question: "How can I provide feedback during the beta?",
    answer: "We love feedback! You can share your thoughts and suggestions through our <a href='https://tally.so/r/waqWQX' target='_blank' rel='noopener noreferrer' class='text-terracotta hover:text-terracotta-dark underline'>feedback form</a>. Your input helps us improve forkast for all families."
  },
  {
    id: "getting-started",
    question: "How do I get started?",
    answer: "Getting started is easy! Just sign up for a free account, add a few of your family's favorite recipes, and start planning your first week of meals. The whole process takes less than 5 minutes."
  },
  {
    id: "meal-types",
    question: "Can I plan more than just dinner?",
    answer: "Yes! forkast supports planning for breakfast, lunch and dinner. You can organize all your family's meals throughout the week and generate shopping lists that include ingredients for all planned meals."
  },
  {
    id: "past-meal-archive",
    question: "Can I see my past meal plans?",
    answer: "Yes! forkast keeps an archive of your past meal planning so you can easily reference what you cooked in previous weeks. This helps you avoid repetition and rediscover family favorites you haven't made in a while."
  },
  {
    id: "ai-suggestions",
    question: "How do AI-powered meal suggestions work?",
    answer: "forkast's AI analyzes your family's recipe collection, past meal patterns, and wellness scores to suggest personalized meal ideas. The AI considers what you've already eaten recently, your family's preferences, and nutritional balance to recommend both new recipes and favorites from your collection."
  },
  {
    id: "ai-personalization",
    question: "Are AI suggestions personalized for my family?",
    answer: "Absolutely! The AI takes into account your specific recipe collection, family's eating patterns, and dietary preferences. The more you use forkast, the better the AI becomes at suggesting meals your family will love while maintaining nutritional variety."
  },
  {
    id: "ai-new-vs-existing",
    question: "Will AI suggestions include new recipes or just my existing ones?",
    answer: "Both! Our AI provides a smart mix of suggestions - it will recommend new recipes to expand your meal repertoire and also suggest existing recipes from your collection that you haven't used recently. This ensures variety while respecting your family's proven favorites."
  },
  {
    id: "family-collaboration",
    question: "How does family collaboration work?",
    answer: "forkast makes meal planning a family activity. Family members can rate recipes, leave comments, suggest changes, and contribute to the weekly meal plan. Everyone stays in sync with shared calendars and can see what's planned for the week."
  },
  {
    id: "recipe-ratings",
    question: "Can I rate and review recipes?",
    answer: "Yes! You and your family members can rate recipes and leave comments about what worked, what didn't, or modifications you made. This helps the AI better understand your preferences and improves future meal suggestions."
  }
];